import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

// MaterialUI
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@material-ui/icons/FavoriteOutlined';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

// app modules: actions
import { addFavouriteContent, removeFavouriteContent } from 'actions/favourites';

function AddToFavouritesItem(props) {
  const {
    component: ItemComponent,
    contentType,
    hash,
    iconClassName,
    itemId,
    onClick,
    ...others
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loggedIn = useSelector(state => state.user.logged_in);
  const isFavourite = useSelector(
    state =>
      state.favourites.loaded && contentType
        ? state.favourites[contentType].includes(itemId)
        : false,
  );
  const favouritesLoaded = useSelector(state => state.favourites.loaded);

  const addItemToFavourites = () => {
    dispatch(addFavouriteContent(itemId, hash, contentType));
    onClick();
  };

  const removeItemFromFavourites = () => {
    dispatch(removeFavouriteContent(itemId, contentType));
    onClick();
  };

  if (loggedIn && favouritesLoaded) {
    if (isFavourite) {
      return (
        <ItemComponent onClick={removeItemFromFavourites} {...others}>
          <ListItemIcon className={iconClassName}>
            <FavoriteOutlinedIcon color="primary" fontSize="large" />
          </ListItemIcon>
          <ListItemText>Remove from {t('favorites')}</ListItemText>
        </ItemComponent>
      );
    }
    return (
      <ItemComponent onClick={addItemToFavourites} {...others}>
        <ListItemIcon className={iconClassName}>
          <FavoriteBorderOutlinedIcon color="primary" fontSize="large" />
        </ListItemIcon>
        <ListItemText>Add to {t('favorites')}</ListItemText>
      </ItemComponent>
    );
  }
  return null;
}

AddToFavouritesItem.propTypes = {
  className: PropTypes.string,
  component: PropTypes.elementType,
  contentType: PropTypes.string.isRequired,
  hash: PropTypes.string,
  iconClassName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

AddToFavouritesItem.defaultProps = {
  className: null,
  component: ListItem,
  hash: '',
  iconClassName: null,
  onClick: () => {},
};

export default AddToFavouritesItem;
